import myaxios from './service'

/**
 * 测试
 */
export const test = (params, vue) => {
  return myaxios.get(params, vue)
}
/**
 * @param {*} res
 */
const axios_response = (res) => {
  return res.data
}
/**
 * @param {userName,password} params
 */
export const login = function (params) {
  return myaxios.post('/user/login', params)
}
/**
 * @param {userName,password} params
 */
export const logout = function (params) {
  return myaxios.get('/user/logout', params)
}

export const existUsername = function (username) {
  return myaxios.get("/user/existUsername", {username})
}

export const existAccount = function (account) {
  return myaxios.get("/user/existAccount", {account})
}

export const existMobile = function (mobile) {
  return myaxios.get("/user/existMobile", {mobile})
}

/**
 * 用户注册
 */
export const getRegister = function (params) {
  return myaxios.post('/user/register', params)
}
/**
 *验证验证码
 */
export const getCurrentCaptcha = function (params) {
  return myaxios.get('/common/getCurrentCaptcha')
}
/**
 * 找回密码
 */
export const findPasswordByEmail = function (params) {
  return myaxios.get('/user/findPasswordByEmail', params)
}
/**
 * 用户信息  修改密码
 */
export const updatePassword = function (params) {
  return myaxios.post('/user/updatePassword', params)
}
/**
 * 用户信息修改
 */
export const updateUser = function (params) {
  return myaxios.post('/user/updateUser', params)
}
/**
 * 获取产品 动态信息
 */
export const getProductDynamics = function (params) {
  return myaxios.get('/index/getProductDynamics', params)
}
/**
 *详情页申请体验
 */
export const applyHotdb = function (params) {
  return myaxios.post('/user/applyHotdb', params)
}
/**
 * 用户申请时点击激活
 */
export const sendActiveLink = function (params) {
  return myaxios.get('/common/sendActiveLink', params)
}
/**
 * 用户留言咨询
 */
export const addConsultingUser = function (params) {
  return myaxios.post('/user/addConsultingUser', params)
}
/**
 * 获取客户案例
 */
export const getAllCustomerCases = function (params) {
  return myaxios.get('/index/customerCase', params)
}
/**
 *获取客户详情
 */
export const getIdCustomerCases = function (params) {
  return myaxios.get(`/index/customerCase/${params.id}`)
}

/**
 * 新闻列表
 */
export const getNews = function (params) {
  return myaxios.post('/index/getNews', params)
}

/***
 *新闻详情
 */
export const getNew = function (params) {
  return myaxios.post('/index/getNew', params)
}

/***
 * 文档下载
 */
export const getDocument = function (params) {
  return myaxios.get('/common/getDocument', params)
}

/***
 *管理授权
 */
export const postApplyLicense = function (params) {
  // return myaxios.upLoadPost(`${getStorage('licenseDomainName')}/license/apply/license`, params);
  return myaxios.upLoadPost('/license/apply/license', params)
}

/***
 *管理授权 下载列表
 */
export const getLicenseRecords = function (params) {
  // return myaxios.get(`${getStorage('licenseDomainName')}/license/licenseRecords`, params);
  return myaxios.get('/license/licenseRecords', params)
}

/***
 *管理授权 获取基本信息
 */
export const getLicenseInfo = function (params) {
  return myaxios.get('/license/licenseInfo', params)
}




// WEBPACK FOOTER //
// ./src/services/index.js